import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

// A fixed offset does not identify a city. Keep it fixed, and use IANA zones
// only when the form explicitly names one, so daylight saving is date-aware.
export function formatCalendarTimezone(
  date,
  configuredTimezone,
  dateOnly = false
) {
  if (date == null || !configuredTimezone) return null;
  const instant = dayjs(date);
  if (!instant.isValid()) return null;
  const zone = String(configuredTimezone).trim();
  const offset = /^(?:GMT|UTC)([+-])(\d{1,2})(?::(\d{2}))?$/.exec(zone);
  let converted;
  let label = zone;
  try {
    if (offset) {
      const hours = Number(offset[2]);
      const minutes = Number(offset[3] || 0);
      if (hours > 18 || minutes > 59 || (hours === 18 && minutes !== 0))
        return null;
      // Shift a UTC clock for display only; the original form timestamp is unchanged.
      const normalized = `${offset[1]}${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
      const total = (hours * 60 + minutes) * (offset[1] === '-' ? -1 : 1);
      converted = instant.utc().add(total, 'minute');
      label = `GMT${normalized}`;
    } else {
      new Intl.DateTimeFormat('en', { timeZone: zone });
      converted = instant.tz(zone);
    }
    return {
      formatted: converted.format(
        dateOnly ? 'D MMMM YYYY' : 'D MMMM YYYY, h:mm:ss a'
      ),
      label,
    };
  } catch {
    return null;
  }
}
